import React, { useEffect, useState } from "react";
import { useWebData } from "../context/WebDataContext"; 
import { db } from "../firebaseConfig";
// 🔥 Changed: Added 'collection', 'onSnapshot' to fetch holidays
import { doc, updateDoc, deleteDoc, collection, onSnapshot } from "firebase/firestore"; 
import * as XLSX from "xlsx";
import Loader from "../components/Loader";

function Attendance() {
  const { attendance, loading } = useWebData();

  // 🔥 Filter States
  const [viewMode, setViewMode] = useState('Month'); 
  const [selectedDate, setSelectedDate] = useState(new Date()); 
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [searchTerm, setSearchTerm] = useState("");
  const [filtered, setFiltered] = useState([]);
  
  const [stats, setStats] = useState({ today: 0, monthly: 0, yearly: 0 });

  // States for Modals
  const [viewData, setViewData] = useState(null);
  const [editData, setEditData] = useState(null);
  const [showHolidays, setShowHolidays] = useState(false);

  // 🔥 NEW: Dynamic Holiday State (Database se aayega)
  const [dbHolidays, setDbHolidays] = useState([]);

  // ==========================================
  // 0. FETCH HOLIDAYS FROM DB (Real-Time)
  // ==========================================
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "holidays"), (snapshot) => {
        const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        
        // Sort by Date (Purana upar, Naya neeche)
        list.sort((a, b) => new Date(a.date) - new Date(b.date));
        
        setDbHolidays(list);
    });
    return () => unsub();
  }, []);

  // ==========================================
  // 1. UNIVERSAL FILTER LOGIC
  // ==========================================
  useEffect(() => {
    if (!attendance) return;

    let result = [...attendance];

    // Search
    if (searchTerm) {
        const lower = searchTerm.toLowerCase();
        result = result.filter(l => {
            const dateStr = l.date ? new Date(l.date).toLocaleDateString('en-GB', {
                day: '2-digit', month: 'short', year: 'numeric'
            }).toLowerCase() : "";
            const locStr = l.location?.address || (typeof l.location === 'string' ? l.location : "");
            const row = `${l.userName} ${locStr} ${l.inTime} ${l.outTime} ${l.note}`.toLowerCase();
            return row.includes(lower) || dateStr.includes(lower);
        });
    }

    // Date Filter (Universal)
    if (viewMode !== 'All') {
        const targetYear = viewMode === 'Year' ? parseInt(selectedYear) : selectedDate.getFullYear();
        const targetMonth = selectedDate.getMonth(); 

        result = result.filter(item => {
            const rawDate = item.date || ""; 
            if (!rawDate) return false;

            let y = 0;
            let m = -1;

            const d = new Date(rawDate);
            if (!isNaN(d.getTime())) {
                y = d.getFullYear();
                m = d.getMonth();
            } else {
                const parts = rawDate.split(/[-/]/);
                if (parts.length === 3) {
                    if (parts[2].length === 4) { 
                        y = parseInt(parts[2]); m = parseInt(parts[1]) - 1;
                    } else if (parts[0].length === 4) { 
                        y = parseInt(parts[0]); m = parseInt(parts[1]) - 1;
                    }
                }
            }

            if (viewMode === 'Year') return y === targetYear;
            if (viewMode === 'Month') return y === targetYear && m === targetMonth;
            return true;
        });
    }

    // Sort
    result.sort((a, b) => new Date(b.date || 0) - new Date(a.date || 0));

    setFiltered(result);
    calculateStats(result); 
  }, [attendance, searchTerm, viewMode, selectedDate, selectedYear]);

  // STATS LOGIC
  const calculateStats = (allData) => {
    const now = new Date();
    const todayStr = now.toISOString().split('T')[0];
    
    let todayCount = 0;
    if(attendance) {
        attendance.forEach(log => {
            if(log.date === todayStr) todayCount++;
        });
    }
    setStats({ 
        today: todayCount, 
        monthly: viewMode === 'Month' ? allData.length : 0, 
        yearly: viewMode === 'Year' ? allData.length : 0 
    });
  };

  // EXCEL
  const downloadExcel = () => {
    const dataToExport = filtered.map(l => ({
        Date: formatDate(l.date),
        Employee: l.userName,
        In_Time: l.inTime,
        Out_Time: l.outTime || "Active",
        Work_Hours: l.workHrs || "-",
        Location_Address: l.location?.address || (typeof l.location === 'string' ? l.location : "-"),
        Map_Link: l.location?.latitude ? `http://maps.google.com/?q=${l.location.latitude},${l.location.longitude}` : "-",
        Notes: l.note || '-'
    }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Attendance");
    XLSX.writeFile(wb, `Attendance_Report_${viewMode}.xlsx`);
  };

  // ACTIONS
  const handleSaveEdit = async () => {
      if(!editData) return;
      try {
          await updateDoc(doc(db, "attendance", editData.id), {
              inTime: editData.inTime,
              outTime: editData.outTime,
              workHrs: editData.workHrs,
              note: editData.note 
          });
          alert("Attendance Updated ✅");
          setEditData(null);
      } catch (e) { alert("Error updating"); }
  };

  const handleDelete = async (id) => {
      if(window.confirm("Delete this log permanently?")) await deleteDoc(doc(db, "attendance", id));
  };

  // Helpers
  const handleMonthChange = (dir) => {
      const d = new Date(selectedDate);
      d.setMonth(d.getMonth() + dir);
      setSelectedDate(d);
  };

  const getYearOptions = () => {
      const currentY = new Date().getFullYear();
      const years = [];
      for(let y = 2024; y <= currentY + 5; y++) years.push(y);
      return years;
  };

  const formatDate = (dateStr) => {
      if(!dateStr) return "-";
      const date = new Date(dateStr);
      return isNaN(date.getTime()) ? dateStr : date.toLocaleDateString('en-GB');
  };

  return (
    <div style={{padding:"20px", fontFamily:"'Segoe UI', sans-serif", backgroundColor:"#f8f9fa", minHeight:"100vh"}}>
      
      {/* STATS CARDS */}
      <div style={{display:"flex", gap:"15px", marginBottom:"20px", flexWrap:"wrap"}}>
          <div style={{...cardStyle, borderLeft:"4px solid green"}}><h4 style={cardTitle}>Present Today</h4><h2 style={cardValue}>{stats.today}</h2></div>
          <div style={{...cardStyle, borderLeft:"4px solid #3b5998"}}><h4 style={cardTitle}>Records (View)</h4><h2 style={cardValue}>{filtered.length}</h2></div>
          <button onClick={() => setShowHolidays(true)} style={btnHoliday}>🎉 View Holidays</button>
      </div>

      {/* HEADER & FILTERS */}
      <div style={headerCard}>
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"15px"}}>
            <h2 style={{margin:0, color:"#2c3e50", display:"flex", alignItems:"center"}}>
                📅 Attendance Log
            </h2>
            <button onClick={downloadExcel} style={btnDownload}>📥 Download Report</button>
        </div>

        <div style={{display:"flex", gap:"10px", flexWrap:"wrap", alignItems:"center", justifyContent:"space-between"}}>
            <div style={{display:"flex", gap:"5px", backgroundColor:"#eee", padding:"4px", borderRadius:"6px"}}>
                {['Month', 'Year', 'All'].map(mode => (
                    <button key={mode} onClick={()=>setViewMode(mode)} 
                        style={{...toggleBtn, backgroundColor: viewMode===mode ? "white" : "transparent", color: viewMode===mode ? "#333" : "#777", boxShadow: viewMode===mode ? "0 2px 5px rgba(0,0,0,0.1)" : "none"}}>
                        {mode}
                    </button>
                ))}
            </div>

            {viewMode === 'Month' && (
                <div style={{display:"flex", alignItems:"center", gap:"10px", backgroundColor:"white", padding:"5px 15px", borderRadius:"6px", border:"1px solid #ddd"}}>
                    <button onClick={()=>handleMonthChange(-1)} style={navBtn}>◀</button>
                    <span style={{fontWeight:"bold", color:"#333", minWidth:"120px", textAlign:"center"}}>
                        {selectedDate.toLocaleDateString('en-US', {month:'long', year:'numeric'})}
                    </span>
                    <button onClick={()=>handleMonthChange(1)} style={navBtn}>▶</button>
                </div>
            )}

            {viewMode === 'Year' && (
                <select 
                    value={selectedYear} 
                    onChange={(e) => setSelectedYear(e.target.value)}
                    style={{padding:"8px", borderRadius:"6px", border:"1px solid #ddd", fontWeight:"bold", fontSize:"14px", cursor:"pointer"}}
                >
                    {getYearOptions().map(y => (
                        <option key={y} value={y}>{y}</option>
                    ))}
                </select>
            )}

            <input type="text" placeholder="🔍 Search Employee, Date..." value={searchTerm} onChange={(e)=>setSearchTerm(e.target.value)} style={searchInput} />
        </div>
      </div>

      {loading ? <Loader /> : (
        <div style={{overflowX:"auto", backgroundColor:"white", borderRadius:"8px", boxShadow:"0 2px 10px rgba(0,0,0,0.05)"}}>
          <table style={tableStyle}>
            <thead>
                <tr style={{backgroundColor:"#2c3e50", color:"white", textAlign:"left"}}>
                    <th style={thStyle}>Date</th>
                    <th style={thStyle}>Employee</th>
                    <th style={thStyle}>In Time</th>
                    <th style={thStyle}>Out Time</th>
                    <th style={thStyle}>Hours</th>
                    <th style={thStyle}>Location</th>
                    <th style={thStyle}>Actions</th>
                </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                  <tr><td colSpan="7" style={{padding:"20px", textAlign:"center", color:"#999"}}>No records found.</td></tr>
              ) : filtered.map(l => (
                <tr key={l.id} style={{borderBottom:"1px solid #eee", height:"45px"}}>
                    <td style={tdStyle}>{formatDate(l.date)}</td>
                    <td style={{...tdStyle, fontWeight:"bold", color:"#2c3e50"}}>{l.userName}</td>
                    <td style={{...tdStyle, color:"green", fontWeight:"bold"}}>{l.inTime}</td>
                    <td style={{...tdStyle, color:"#c0392b", fontWeight:"bold"}}>{l.outTime || "-"}</td>
                    <td style={tdStyle}>{l.workHrs}</td>
                    <td style={{...tdStyle, fontSize:"11px", maxWidth:"150px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}} title={l.location?.address || l.location}>
                        {l.location?.address || (typeof l.location === 'string' ? l.location : "-")}
                    </td>
                    <td style={tdStyle}>
                        <div style={{display:"flex", gap:"4px"}}>
                            <button onClick={() => setViewData(l)} style={btnIconEye} title="View Details">👁️</button>
                            <button onClick={() => setEditData(l)} style={btnIconEdit} title="Edit Time">✏️</button>
                            <button onClick={() => handleDelete(l.id)} style={btnIconDelete} title="Delete">🗑️</button>
                        </div>
                    </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* VIEW MODAL */}
      {viewData && (
        <div style={modalOverlay}>
          <div style={modalContent}>
            <h3 style={{color:"#2c3e50", marginTop:0, borderBottom:"1px solid #eee", paddingBottom:"10px"}}>📍 Log Details</h3>
            <div style={{fontSize:"13px", lineHeight:"1.6"}}>
                <p><strong>📅 Date:</strong> {formatDate(viewData.date)}</p>
                <p><strong>👤 Name:</strong> {viewData.userName}</p>
                <div style={{display:"flex", justifyContent:"space-between", background:"#f9f9f9", padding:"5px", borderRadius:"5px"}}>
                    <span>🟢 In: <strong>{viewData.inTime}</strong></span>
                    <span>🔴 Out: <strong>{viewData.outTime || "Active"}</strong></span>
                </div>
                <p><strong>⏳ Work Hours:</strong> {viewData.workHrs || "Calculating..."}</p>
                <p><strong>📍 Location:</strong> {viewData.location?.address || (typeof viewData.location === 'string' ? viewData.location : "Unknown")}</p>
                <p><strong>📝 Note:</strong> {viewData.note || "-"}</p>
            </div>
            <button onClick={() => setViewData(null)} style={btnClose}>Close</button>
          </div>
        </div>
      )}

      {/* EDIT MODAL */}
      {editData && (
        <div style={modalOverlay}>
          <div style={modalContent}>
            <h3 style={{color:"#f39c12", marginTop:0}}>✏️ Correct Time</h3>
            <div style={{display:"flex", gap:"10px"}}>
                <div style={{flex:1}}>
                    <label style={labelStyle}>In Time</label>
                    <input type="text" value={editData.inTime} onChange={(e)=>setEditData({...editData, inTime:e.target.value})} style={modalInput} placeholder="HH:MM AM"/>
                </div>
                <div style={{flex:1}}>
                    <label style={labelStyle}>Out Time</label>
                    <input type="text" value={editData.outTime} onChange={(e)=>setEditData({...editData, outTime:e.target.value})} style={modalInput} placeholder="HH:MM PM"/>
                </div>
            </div>
            <label style={labelStyle}>Total Hours</label>
            <input type="text" value={editData.workHrs} onChange={(e)=>setEditData({...editData, workHrs:e.target.value})} style={modalInput}/>
            <div style={{marginTop:"15px", textAlign:"right"}}>
                <button onClick={()=>setEditData(null)} style={btnCancel}>Cancel</button>
                <button onClick={handleSaveEdit} style={btnSave}>Update</button>
            </div>
          </div>
        </div>
      )}

      {/* 🔥 HOLIDAYS MODAL (Now Dynamic) */}
      {showHolidays && (
        <div style={modalOverlay}>
            <div style={modalContent}>
                <h3 style={{color:"#e67e22", marginTop:0, borderBottom:"1px solid #eee", paddingBottom:"10px"}}>🎉 All Holidays</h3>
                
                {dbHolidays.length === 0 ? (
                    <p style={{textAlign:"center", color:"#999"}}>No holidays found.</p>
                ) : (
                    <div style={{maxHeight:"300px", overflowY:"auto"}}>
                        <ul style={{paddingLeft:"20px", fontSize:"13px"}}>
                            {dbHolidays.map(h => (
                                <li key={h.id} style={{marginBottom:"8px"}}>
                                    <strong>{formatDate(h.date)}:</strong> {h.name}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
                
                <button onClick={() => setShowHolidays(false)} style={btnClose}>Close</button>
            </div>
        </div>
      )}
    </div>
  );
}

// STYLES
const headerCard={backgroundColor:"white", padding:"20px", borderRadius:"10px", boxShadow:"0 2px 8px rgba(0,0,0,0.05)", marginBottom:"20px"};
const tableStyle={width:"100%", borderCollapse:"collapse", fontSize:"13px"};
const thStyle={padding:"12px 15px", borderBottom:"2px solid #eee", fontSize:"12px", textTransform:"uppercase", letterSpacing:"0.5px"};
const tdStyle={padding:"10px 15px", verticalAlign:"middle"};
const toggleBtn={border:"none", padding:"6px 12px", borderRadius:"5px", cursor:"pointer", fontSize:"13px", fontWeight:"600", transition:"0.2s"};
const navBtn={background:"none", border:"none", cursor:"pointer", fontSize:"16px", color:"#555"};
const searchInput={padding:"8px 12px", border:"1px solid #ddd", borderRadius:"6px", width:"200px", outline:"none"};
const btnDownload={backgroundColor:"#27ae60", color:"white", border:"none", padding:"8px 15px", borderRadius:"5px", cursor:"pointer", fontWeight:"bold", fontSize:"13px"};
const btnIconEye={backgroundColor:"#e3f2fd", color:"#1976d2", border:"1px solid #bbdefb", padding:"5px 8px", borderRadius:"4px", cursor:"pointer", marginRight:"5px"};
const btnIconEdit={backgroundColor:"#fff3e0", color:"#e67e22", border:"1px solid #ffe0b2", padding:"5px 8px", borderRadius:"4px", cursor:"pointer", marginRight:"5px"};
const btnIconDelete={backgroundColor:"#fff", color:"#777", border:"1px solid #ddd", padding:"5px 8px", borderRadius:"4px", cursor:"pointer"};
const btnHoliday={backgroundColor:"#e67e22", color:"white", border:"none", borderRadius:"5px", padding:"8px 12px", cursor:"pointer", fontWeight:"bold", fontSize:"12px", display:"flex", alignItems:"center", justifyContent:"center"};
const modalOverlay={position:"fixed", top:0, left:0, width:"100%", height:"100%", background:"rgba(0,0,0,0.5)", display:"flex", justifyContent:"center", alignItems:"center", zIndex:1000};
const modalContent={background:"white", padding:"25px", borderRadius:"12px", width:"350px", boxShadow:"0 10px 30px rgba(0,0,0,0.2)", position:"relative"};
const modalInput={width:"100%", padding:"8px", margin:"5px 0", borderRadius:"4px", border:"1px solid #ccc", boxSizing:"border-box", fontSize:"13px"};
const labelStyle={fontSize:"11px", fontWeight:"bold", color:"#555"};
const btnSave={backgroundColor:"#27ae60", color:"white", border:"none", padding:"8px 15px", borderRadius:"4px", cursor:"pointer", marginLeft:"5px"};
const btnCancel={backgroundColor:"#95a5a6", color:"white", border:"none", padding:"8px 15px", borderRadius:"4px", cursor:"pointer"};
const btnClose={marginTop:"15px", backgroundColor:"#333", color:"white", border:"none", padding:"8px", borderRadius:"4px", width:"100%", cursor:"pointer"};
const cardStyle = { backgroundColor: "white", padding: "15px", borderRadius: "10px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)", textAlign: "center", minWidth:"150px", flex:1 };
const cardTitle = { margin:0, color:"#7f8c8d", fontSize:"12px", textTransform:"uppercase", letterSpacing:"0.5px" };
const cardValue = { margin:"5px 0 0 0", color:"#333", fontSize:"24px", fontWeight:"bold" };

export default Attendance;